// extracted by mini-css-extract-plugin
export default {"wrapper":"IBM_wrapper__MQeTJ","ibmBtn":"IBM_ibmBtn__VCmR9","Btn1":"IBM_Btn1__mZktn","Btn2":"IBM_Btn2__a0Sdo","Btn3":"IBM_Btn3__ZbxEh","ibmBlockWrapper":"IBM_ibmBlockWrapper__VR-8n"};